/* eslint-disable no-shadow */
import { useParams } from 'react-router-dom';
import WritersForm from './writersForm';

function WritersCreate() {
  const { id } = useParams();
  const isUpdate = !!id;

  return (
    <div className="flex flex-wrap">
      <div className={`w-full ${isUpdate ? 'bg-sentric-menu-gray' : 'bg-sentric-menu-gray'} lg:p-6 p-4  lg:min-h-screen-minus-header`}>

        <WritersForm id={id} />

      </div>
    </div>
  );
}
export default WritersCreate;
